import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { OldUser, User } from "JS/Models";

export interface UserHistoryState {
    login_details?: OldUser[];
}
const initialState: UserHistoryState = {
    login_details: [],
};

export const userHistoryStateSlice = createSlice({
    name: "UserHistoryState",
    initialState,
    reducers: {
        setLoginDetails: (state, data: PayloadAction<User>) => {
            const user = {
                first_name: data.payload.firstName,
                last_name: data.payload.lastName,
                member_id: data.payload.memberId,
            };

            state = {
                ...state,
                login_details: [user, ...state.login_details],
            };

            return state;
        },
        clearHistory: () => {
            return initialState;
        },
    },
});
export const { clearHistory, setLoginDetails } = userHistoryStateSlice.actions;
